module.exports = __webpack_public_path__ + "img/icon10.8a9748b3.png";